/**
 * The URL path this SPA is mounted at, with NO trailing slash.
 *
 * Derived from Vite's `base` (vite.config.ts, set by the VITE_BASE_PATH build
 * arg) — Vite exposes that value as `import.meta.env.BASE_URL` and bakes it
 * into the bundle at BUILD time, which is why the mount path is a property of
 * the image rather than something the container can be told at startup.
 *
 * One knob drives all three places the mount path has to appear, so they can
 * never drift out of step:
 *   - the asset URLs Vite writes into index.html   (Vite, from `base`)
 *   - the router's basename                        (App.tsx)
 *   - the API request prefix                       (lib/api.ts)
 *
 * Default deploy (`base: '/'`) gives '' — every consumer below then behaves
 * exactly as it did before this existed, so dev and the laptop stack are
 * untouched. A subpath deploy (`base: '/group-mobility/'`) gives
 * '/group-mobility'.
 *
 * Reverse proxies that STRIP the prefix are still fine: the browser is what
 * needs these paths to carry it, and the backend only ever sees the stripped
 * remainder. See infra/docker/DEPLOY-SUBPATH.md.
 */
export const BASE_PATH = import.meta.env.BASE_URL.replace(/\/+$/, '')
